export default (root: string) => ({
    projectGroup: (projectGroupId: string) => {
        const specificRoot = `${root}/projectGroups/${projectGroupId}`;
        return {
            root: specificRoot,
        };
    }
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/projects/components/ProjectGroupLayout/projectGroupRouteLinks.ts